<template>
  <div class="news-detail">
    <common-header is-scrolled="true" :current-section="'news'" />
   
    <div class="detail-container">
      <!-- 标题部分 -->
      <div class="news-header">
        <h1>{{ $t('news.article53.content.title') }}</h1>
        <div class="news-date">{{ $t('news.article53.content.date') }}</div>
      </div>

      <!-- 视频预览部分 -->
      <div class="video-preview" @click="openVideo">
        <img src="@/assets/news/3.jpg" alt="Power Plant Carbon Capture" class="preview-image">
        <div class="play-button">
          <i class="el-icon-video-play"></i>
        </div>
      </div>

      <!-- 文字描述部分 -->
      <div class="news-content">
        <div class="news-text">
          {{ $t('news.article53.content.text')[0] }}
        </div>
        
        <div class="credits">
          <h3>{{ $t('news.article53.content.credits.title') }}</h3>
          <p v-for="(member, index) in $t('news.article53.content.credits.members')" :key="index">
            {{ member }}
          </p>
        </div>
      </div>
      <div class="news-back">
      </div>
    </div>
    <common-section type="footer" id="contact" />
  </div>
</template>

<script>
import CommonHeader from '@/components/CommonHeader.vue';
import CommonSection from '@/components/CommonSection.vue';

export default {
  name: 'NewsDetail53',
  components: { CommonHeader, CommonSection },
  computed: {
    currentLang() {
      return this.$i18n.locale;
    },
   
  },
  methods: {
    openVideo() {
      window.open('https://news.cgtn.com/news/2021-11-24/Vlog-How-carbon-dioxide-is-captured-at-a-power-generation-plant--15rrT2t2AvK/index.html', '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.news-detail {
  min-height: 100vh;
  background-color: #f9f9f9;
  padding-top: 180px;
  
  .detail-container {
    max-width: 75%;
    margin: 0px auto 100px auto;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 24px rgba(0,0,0,0.08);
    padding: 60px 40px 40px 40px;
    position: relative;
    z-index: 2;

    .news-header {
      text-align: center;
      margin-bottom: 40px;

      h1 {
        font-size: 32px;
        color: #333;
        margin-bottom: 16px;
        line-height: 1.4;
      }

      .news-date {
        color: #666;
        font-size: 16px;
      }
    }

    .video-preview {
      position: relative;
      width: 100%;
      max-width: 800px;
      margin: 0 auto 40px;
      cursor: pointer;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

      .preview-image {
        width: 100%;
        height: auto;
        display: block;
      }

      .play-button {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 80px;
        height: 80px;
        background: rgba(64, 158, 255, 0.8);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;
        cursor: pointer;

        &:hover {
          transform: translate(-50%, -50%) scale(1.1);
          background: rgba(64, 158, 255, 0.9);
        }

        i {
          color: white;
          font-size: 40px;
        }
      }
    }

    .news-content {
      max-width: 800px;
      margin: 0 auto;
      background: white;
      padding: 40px;
      border-radius: 8px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

      .news-text {
        font-size: 18px;
        line-height: 1.8;
        color: #333;
        margin-bottom: 40px;
      }

      .credits {
        border-top: 1px solid #eee;
        padding-top: 20px;
        margin-top: 20px;

        h3 {
          font-size: 18px;
          color: #333;
          margin-bottom: 16px;
        }

        p {
          font-size: 16px;
          color: #666;
          line-height: 1.6;
          margin-bottom: 8px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    .news-back {
      text-align: right;
      margin-top: 30px;
      a {
        color: #1d2088;
        text-decoration: underline;
        font-size: 16px;
      }
    }
  }
}

@media (max-width: 768px) {
  .news-detail {
    padding-top: 120px;
    
    .detail-container {
      max-width: 90%;
      padding: 30px 20px;
      
      .news-header {
        h1 {
          font-size: 24px;
        }
      }

      .video-preview {
        .play-button {
          width: 60px;
          height: 60px;

          &:hover {
            transform: translate(-50%, -50%) scale(1.1);
          }

          i {
            font-size: 30px;
          }
        }
      }

      .news-content {
        padding: 20px;

        .news-text {
          font-size: 16px;
        }

        .credits {
          h3 {
            font-size: 16px;
          }

          p {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style> 